import { Inject, Injectable } from "@angular/core";
import { USER_GATEWAY } from "@app/app.providers";
import { UserEntity } from "@arch/domain/entity/user.entity";
import { IUserGateway } from "@arch/domain/gateway/user.gateway.interface";

@Injectable({
    providedIn: "root"
})
export class AuthController {
    constructor(
        @Inject(USER_GATEWAY) private readonly userGateway: IUserGateway
    ) {}

    public async execute(input: {
        email: string;
        password: string;
    }): Promise<{ token: string; refreshToken: string; user: UserEntity }> {
        return await this.userGateway.authenticate(input);
    }
}
